const listeners = new Map()
export function onRefresh(key, callback) { listeners.set(key, callback) }
export function offRefresh(key) { listeners.delete(key) }
export function emitRefresh(key) {
  const cb = listeners.get(key)
  if (cb) { cb(); return true }
  return false
}
